var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"session-handler"}},[_c('login-idle',{attrs:{"time-remaining":_vm.timeRemaining,"show":_vm.showLoginIdle},on:{"continue":_vm.pingLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }